<red-dot *ngIf="(hintsEnabled$ | async) !== false" [title]="title" [footer]="footer">
  <ng-content></ng-content>
</red-dot>
